import { css } from "emotion";

import { colors, fonts, icons } from "@cobliteam/base-components/src/styles";

export const tab = (hideTab: boolean) => css`
  margin-right: ${hideTab ? "-440px" : "0"};
  transition: all 0.5s ease;
`;

export const loadingPlaceholder = css`
  margin: 30px 20px;
`;

const banner = css`
  border-radius: 5px;
  display: flex;
`;

export const filterBanner = css`
  ${banner}
  justify-content: space-between;
  padding: 7px 10px;
  background-color: ${colors.gray.lightest};
  margin-bottom: 30px;
`;

export const lastRouteBanner = css`
  ${banner}
  display: flex;
  padding: 10px;
  background-color: ${colors.shadows.getShadow(colors.warning.default, 0.08)};
  align-items: center;
  margin: 20px 0px 0px;
`;

export const bannerContent = css`
  display: flex;
  align-items: flex-start;
`;

export const bannerText = css`
  color: ${colors.gray.dark};
`;

export const badge = css`
  display: flex;
  align-items: center;
  border-radius: 3px;
  padding: 4px 10px;
  justify-content: center;
  font-size: ${fonts.size.smallest};
  font-weight: ${fonts.weight.medium};

  & svg {
    margin-right: 10px;
    width: ${icons.size.smallest};
    height: ${icons.size.smallest};
  }
`;

export const badgeInProgress = css`
  background-color: ${colors.shadows.getShadow(colors.primary.default, 0.1)};
  color: ${colors.primary.default};
`;

export const trackingInProgressMessage = css`
  font-size: ${fonts.size.smallest};
  padding: 10px 0px;
  color: ${colors.gray.dark};
`;

export const goToMapBtn = css`
  font-weight: ${fonts.weight.bold};

  && {
    color: ${colors.primary.default};
  }

  :visited,
  :hover {
    color: ${colors.primary.default};
  }
`;

export const placeholder = css`
  margin: 100px auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const placeholderIcon = css`
  height: 100px;
  width: 100px;
`;

export const warningIcon = css`
  margin-right: 10px;
  color: ${colors.warning.default};
  flex-shrink: 0;
`;

export const placeholderText = css`
  width: 100%;
  margin-top: 20px;
  text-align: center;
  white-space: pre-line;
`;

export const placeholderButton = css`
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;
